import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { BRAND_CURATION_TASK_QUERY } from '../graphql/queries'
import { FETCH_BRAND_CURATION_TASK } from '../redux/action-types'
import { cleanupFetchBrandCurationTask } from '../redux/actions'

const useBrandCurationTaskQuery = id => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchBrandCurationTask)

  const { isLoading, error, data } = useSelector(
    store => store.brandCurationTasks.brandCurationTask,
  )

  const refetch = useCallback(
    idParam =>
      apolloService.query({
        query: BRAND_CURATION_TASK_QUERY,
        variables: {
          id: idParam,
        },
        dispatch,
        action: FETCH_BRAND_CURATION_TASK,
      }),
    [dispatch],
  )

  useEffect(() => {
    refetch(id)
  }, [refetch, id])

  return { isLoading, error, data, refetch }
}

export default useBrandCurationTaskQuery
